import React from "react";
import style from "./index.module.scss";
import { InputNumber } from "antd";
import { useAtomValue } from "jotai";
import { disabledAtom } from "../../store";
import { useParams } from "react-router-dom";

const Index = ({
    title,
    percent,
    onChangePercent,
    isShowTips = true,
    help,
    exp
}: {
    title: string;
    percent?: number;
    onChangePercent?: (val: number) => void;
    isShowTips?: boolean;
    help?: string;
    exp?: React.ReactElement;
}) => {
    const { courseNo, courseSeq } = useParams<StringMap>();

    const disabled = useAtomValue(disabledAtom({ courseNo, courseSeq }));
    return (
        <div className={style.root}>
            <div className={style.left}>
                <img src={require("./images/icon1.png")} alt="" />
                <b>{title}</b>
                {exp}
                {isShowTips && (
                    <>
                        <InputNumber
                            min={0}
                            max={100}
                            precision={1}
                            value={percent}
                            onChange={e => onChangePercent?.(e || 0)}
                            disabled={disabled}
                        />
                        %
                    </>
                )}
            </div>
            {isShowTips && (
                <>
                    <span className={style.introduce}>
                        说明：成绩规则内置项无法修改，自定义考核项可以修改成绩规则。总权重需要满足100%（超出或不足将无法保存）。{" "}
                    </span>
                    <div className={style.label}>
                        <img src={require("./images/icon2.png")} alt="" />
                        必填项
                    </div>
                    <div className={style.label}>
                        <img src={require("./images/icon3.png")} alt="" />
                        自定义考核项
                    </div>
                </>
            )}
            {help && (
                <span className={style.introduce}>
                    说明:
                    {help}
                </span>
            )}
        </div>
    );
};

export default Index;
